import { FC, useEffect } from 'react';

export interface EmbedProps {
  embed: any;
}

const Embed: FC<EmbedProps> = ({ embed }) => {
  useEffect(() => {
    setTimeout(() => {
      window.dispatchEvent(new Event('embed-mounted'));
    }, 2500);
  }, []);
  return (
    <div className="not-prose mx-auto w-fit min-w-full">
      <div dangerouslySetInnerHTML={{ __html: embed }}></div>
    </div>
  );
};

export default Embed;
